import type { Except } from "type-fest";
import type { IsoAndUnixTimestamp} from "../date-time/iso-and-unix";
import { nowIsoAndUnix } from "../date-time/iso-and-unix";
import type { PubSubEventId} from "./pubsub-event-id";
import { pubsubEventIdFactory } from "./pubsub-event-id";

type NoSpecificData = undefined;
type PubSubEventType<
    Namespace extends string,
    SpecificType extends string = string,
> = `${Namespace}:${SpecificType}`;
type PubSubEventBase<
    Namespace extends string,
    SpecificType extends string = string,
    EventData extends Record<string, unknown> | undefined = undefined,
> = {
    _id: PubSubEventId;
    type: PubSubEventType<Namespace, SpecificType>;
    namespace: Namespace;
    triggeredAt: IsoAndUnixTimestamp;
    triggeredBy: string;
    data: EventData;
    tags: string[];
};

type CreatePubSubEventBaseParams<
    Namespace extends string,
    SpecificType extends string = string,
    EventData extends Record<string, unknown> | undefined = undefined,
> = Except<
    PubSubEventBase<Namespace, SpecificType, EventData>,
    "_id" | "triggeredAt" | "tags"
> & {
    _id?: PubSubEventId;
    triggeredAt?: IsoAndUnixTimestamp;
    tags?: [];
};

const createPubSubEventBase = <
    Namespace extends string,
    SpecificType extends string = string,
    EventData extends Record<string, unknown> | undefined = undefined,
>(
    params: CreatePubSubEventBaseParams<Namespace, SpecificType, EventData>,
) => {
    return {
        ...params,
        _id: params._id ?? pubsubEventIdFactory(),
        triggeredAt: params.triggeredAt ?? nowIsoAndUnix(),
        tags: params.tags ?? [],
    };
};

export { createPubSubEventBase };
export type {
    CreatePubSubEventBaseParams,
    NoSpecificData,
    PubSubEventBase,
    PubSubEventType,
};
